export default '/src/assets/webgl/sfx_audio/sfx.mp3'